import React, { useState } from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { Col, Form } from "react-bootstrap";
import { AutoSuggestions } from "../viewLayout/searchBox/AutoSuggestions";
import { MenuDropdowns } from "./MenuDropdowns";
import { MobileSearchBox } from "./parts/MobileSearchBox";
import { SearchBox } from "../viewLayout/searchBox/SearchBox";
import { getParam } from "lib/routing";

export const MenuFilterBar = () => {
  const isMobile = useIsMobile();
  return <ErrorBoundary>{isMobile ? <MobileSearchBox /> : <DesktopMenuFilterBar />}</ErrorBoundary>;
};

export const DesktopMenuFilterBar = () => {
  const defaultKeyword = getParam("") || getParam("q") || getParam("title") || "";
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [isAcVisible, setAcVisible] = useState();
  const [isSearching, setIsSearching] = useState();

  return (
    <Form onSubmit={(ev) => ev.preventDefault()}>
      <Form.Row className="menuFilterBar d-flex pl-2 pt-2 mt-0">
        <MenuDropdowns />

        <Col className="ml-auto mr-0 pl-3 maxw-490 minw-208">
          <SearchBox
            keyword={keyword}
            setKeyword={setKeyword}
            setAcVisible={setAcVisible}
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            className="rounded-xl-left border-primary border-2"
            size="sm"
            isDropdownVisible={false}
            autoFocus
          />
        </Col>
      </Form.Row>
      {isAcVisible && <AutoSuggestions keyword={keyword} setKeyword={setKeyword} setIsSearching={setIsSearching} />}
    </Form>
  );
};
